import { Moon, Sun } from "lucide-react";

export const ThemeToggle = ({ theme, onToggle }) => (
  <button
    type="button"
    onClick={onToggle}
    data-testid="theme-toggle-button"
    aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
    className="grid h-10 w-10 place-items-center rounded-none border border-line text-ink transition-[background-color,transform] duration-300 hover:bg-surface"
  >
    {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
  </button>
);
